#import "./siteInfo.gql"
#import "../user/userInfo.gql"

mutation CreateSite(
  $id: ID!
  $companyId: ID!
  $name: String!
  $timeZoneDisplayName: String!
  $externalId: ID
  $externalAccountUuid: ID
  $startOfDay: String!
  $settings: JsonString!
  $seedSampleData: Boolean
) {
  createSite(
    id: $id
    companyId: $companyId
    name: $name
    timeZoneDisplayName: $timeZoneDisplayName
    externalId: $externalId
    externalAccountUuid: $externalAccountUuid
    startOfDay: $startOfDay
    settings: $settings
    seedSampleData: $seedSampleData
  ) {
    site {
      ...siteInfo
    }
  }
}

mutation UpdateSite(
  $id: ID!
  $companyId: ID!
  $name: String!
  $timeZoneDisplayName: String!
  $externalId: ID
  $externalAccountUuid: ID
  $startOfDay: String!
  $settings: JsonString!
) {
  updateSite(
    id: $id
    name: $name
    companyId: $companyId
    timeZoneDisplayName: $timeZoneDisplayName
    externalId: $externalId
    externalAccountUuid: $externalAccountUuid
    startOfDay: $startOfDay
    settings: $settings
  ) {
    site {
      ...siteInfo
    }
  }
}

query GetAssignableSites($role: String, $companyId: ID) {
  assignableSites(role: $role, companyId: $companyId) {
    ...siteInfo
  }
}

query GetAssignedSites {
  assignedSites {
    ...siteInfo
  }
}

query GetSite($id: ID!) {
  site(id: $id) {
    ...siteInfo
    users {
      ...userInfo
    }
  }
}

mutation DeleteSite($id: ID!) {
  deleteSite(id: $id) {
    name
  }
}

mutation ResetSite($id: ID!, $preset: String!, $relativeDate: ISO8601DateTime!) {
  resetSite(id: $id, preset: $preset, relativeDate: $relativeDate) {
    name
  }
}
